export const styles = {
  borderRadius: "8px",
  "& .MuiDataGrid-cell": {
    fontSize: "12px",
  },
  "& .MuiDataGrid-columnHeaders": {
    fontSize: "12px",
  },
  "& .MuiDataGrid-columnHeaders": {
    fontSize: "13px",
  },
  "& .MuiDataGrid-cell": {
    color: "#4a5568",
    backgroundColor: "#FFF !important",
    fontSize: "12px",
  },
  "& .MuiDataGrid-row--borderBottom": {
    background: "#F8F8FB !important",
  },
  "& .MuiDataGrid-cell:focus-within": {
    borderTop: "1px solid rgba(224, 224, 224, 1) !important",
  },
}
